// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"13":"049d8240","270":"6882e9ff","968":"9697ecc5"}[chunkId] + ".js";
};